import { combineReducers } from '@reduxjs/toolkit';
import extraction from './extraction/root';
import limits from './limits/root';
import priceManager from './priceManager/root';
import strategy from './strategy/root';

const root = combineReducers({ extraction, strategy, limits, priceManager });

export default root;

export type IpaState = ReturnType<typeof root>;
